(() => {
  const root = window.DINUZO || {};
  if (root.analytics) return;

  const supportedEvents = new Set([
    'view_item',
    'view_collection',
    'search',
    'add_to_cart',
    'remove_from_cart',
    'view_cart',
    'view_bundle',
    'add_bundle_to_cart',
    'begin_checkout',
    'add_shipping_info',
    'add_payment_info',
    'purchase',
    'upsell_accept'
  ]);

  let context = {};
  const contextNode = document.getElementById('dinuzo-analytics-context');

  if (contextNode) {
    try {
      context = JSON.parse(contextNode.textContent);
    } catch {
      context = {};
    }
  }

  const emit = (eventName, data = {}) => {
    if (!supportedEvents.has(eventName)) return false;

    window.dispatchEvent(
      new CustomEvent('dinuzo:analytics', {
        detail: {
          event: eventName,
          context,
          data
        }
      })
    );

    return true;
  };

  window.DINUZO = {
    ...root,
    analytics: Object.freeze({
      version: '1.0',
      supportedEvents: Object.freeze([...supportedEvents]),
      context: Object.freeze({ ...context }),
      emit
    })
  };
})();
